package com.exura.util

fun jso(block: dynamic.() -> Unit): dynamic {
    val o = js("{}")
    block(o)
    return o
}
